import React, { useEffect, useState, Suspense, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import { useViewport } from "./helper/useViewPort";
import AppRoutes from "./routes/AppRoutes";
import { getLocalStorage } from "./helper/localStorageHelper";
import { AppConstant } from "./constant/AppConstant";
import { ROUTES } from "./routes/Routes";
import { setNavigate } from "./helper/Utility";
import "./assets/scss/Default.scss";
import "./assets/scss/Landing.scss";
import "./assets/scss/Icons.scss";
import { clearCart, getCart } from "./pages/cart/CartMangement";

const Navbar = React.lazy(() => import("./layouts/Navbar"));
const Topbar = React.lazy(() => import("./layouts/Topbar"));
const Footer = React.lazy(() => import("./layouts/Footer"));

const App = () => {
  const { width } = useViewport();
  const location = useLocation();
  const navigate = useNavigate();
  setNavigate(navigate);
  
  const layoutProps = {
    layoutColor: "light",
    layoutWidth: "fluid",
    menuPosition: "scrollable",
    topbarTheme: "dark",
    showTwoToneIcons: true,
    leftSideBarTheme: "light",
  };

  const is404Page = location.pathname === "/404";
  const isAuthRoute = location.pathname.includes("/auth");
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(!!getLocalStorage(AppConstant.authToken));
  const [isMenuOpened, setIsMenuOpened] = useState<boolean>(false);

  useEffect(() => {
    if (getCart().items.length == 0) {
      clearCart();
    }
    const token = getLocalStorage(AppConstant.authToken);
    if (token) {
      setIsAuthenticated(true);
      if (location.pathname === ROUTES.LOGIN.path) {
        navigate(ROUTES.DASHBOARD.path, { replace: true });
      }
    } else {
      setIsAuthenticated(false);
      if (!location.pathname.startsWith("/auth")) {
        navigate(ROUTES.LOGIN.path, { replace: true });
      }
    }
  }, [location.pathname, navigate]);

  useEffect(() => {
    const changeHTMLAttribute = (attribute: string, value: string): void => {
      if (document.body) {
        document.getElementsByTagName("html")[0].setAttribute(attribute, value);
      }
    };

    changeHTMLAttribute("data-layout", "horizontal");
    changeHTMLAttribute("data-menu-color", layoutProps.leftSideBarTheme);
    changeHTMLAttribute("data-bs-theme", layoutProps.layoutColor);
    changeHTMLAttribute("data-layout-width", layoutProps.layoutWidth);
    changeHTMLAttribute("data-menu-position", layoutProps.menuPosition);
    changeHTMLAttribute(
      "data-menu-icon",
      layoutProps.showTwoToneIcons ? "twotones" : "default"
    );
    changeHTMLAttribute("data-topbar-color", layoutProps.topbarTheme);
  }, [layoutProps]);

  useEffect(() => {
    if (width < 1140) {
      document.body.classList.add("is-mobile");
    } else {
      document.body.classList.remove("is-mobile");
    }
  }, [width]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const openMenu = () => {
    setIsMenuOpened(!isMenuOpened);
    document.body.classList.toggle("sidebar-enable", !isMenuOpened);
  };

  return (
    <div id="wrapper">
      <div>
        {!isAuthRoute && !is404Page && (
          <Suspense fallback={null}>
            <Navbar isMenuOpened={isMenuOpened} />
            <Topbar openLeftMenuCallBack={openMenu} topbarDark={true} />
          </Suspense>
        )}

        <div className="content-page">
          <div className="content" style={{maxWidth : "100%"}}>
            <Container fluid>
              <Suspense fallback={null}>
                <AppRoutes isAuthenticated={isAuthenticated} />
              </Suspense>
            </Container>
          </div>

          {!isAuthRoute && !is404Page && (
            <Suspense fallback={null}>
              <Footer />
            </Suspense>
          )}
        </div>
      </div>
    </div>
  );
};

export default App;